import moment from "moment"
import {Avatar, Button, ButtonGroup, Flex, Heading, HStack, IconButton, Tag, Td, Text, Tr, useDisclosure} from "@chakra-ui/react"
import {Container, Dev, Form, Icon, Label, Pressable, Searchable, Table} from "components"
import {useDistributorsList, useLocCities, useLocRegionState} from "hooks"
import {useEffect, useState} from "react"
import {useNavigate} from "react-router"
import {Moment} from "config";
import CreateDistributor from "./create"

export default function Distributors() {

    const navigate = useNavigate()
    const createDistributor = useDisclosure()
    const [term, setTerm] = useState(null)
    const [page, setPage] = useState(1)
    const [stateId, setStateId] = useState(null)
    const [cityId, setCityId] = useState(null)
    const [condition, setCondition] = useState(null)
    const [region, setRegion] = useState(null)

    useEffect(() => {
        setCityId(null);
        setStateId(null);
    }, [region]);

    useEffect(() => {
        setCityId(null);
    }, [stateId]);

    const distributors = useDistributorsList(
        page,
        term,
        region,
        stateId,
        cityId,
        condition,
        // period,
    )

    const states = useLocRegionState(region)
    const cities = useLocCities(stateId)

    let statesList = states.data?.map(item => ({label: item.name, value: item.id})) ?? []
    statesList = [{label: 'Todos', value: null}, ...statesList]

    let cityList = cities.data?.map(item => ({label: item.name, value: item.id})) ?? []
    cityList = [{label: 'Todas', value: null}, ...cityList]

    const conditionOptions = [
        {label: 'Todas', value: null},
        {label: 'Vendas suspensas', value: 'suspended'},
        {label: 'Bloqueados', value: 'blocked'},
        {label: 'Em Operação', value: 'active'}
    ];

    const regionsOptions = [
        {label: 'Todas', value: null},
        {label: 'Norte', value: 'Norte'},
        {label: 'Nordeste', value: 'Nordeste'},
        {label: 'Centro-Oeste', value: 'Centro-Oeste'},
        {label: 'Sudeste', value: 'Sudeste'},
        {label: 'Sul', value: 'Sul'},
    ];

    const formatPhoneNumber = (phone) => {
        if (!phone) return ''

        let numbers = phone.toString().replaceAll(/\D/g, '')

        let nationalNumber
        if (numbers.length >= 10) {
            nationalNumber = numbers.slice(-11)
        } else {
            return phone
        }

        if (nationalNumber.length === 11) {
            return `(${nationalNumber.slice(0, 2)}) ${nationalNumber.slice(2, 7)}-${nationalNumber.slice(7, 11)}`
        } else if (nationalNumber.length === 10) {
            return `(${nationalNumber.slice(0, 2)}) ${nationalNumber.slice(2, 6)}-${nationalNumber.slice(6, 10)}`
        }

        return phone
    }

    const handleClearFilters = () => {
        setTerm('');
        setRegion(null);
        setStateId(null);
        setCityId(null);
        setCondition(null);
        window.location.reload();
    }

    return (
        <Container mt={10}>

            <Flex justifyContent="space-between" alignItems="center">
                <Heading children="Núcleos de Distribuição"/>
                <ButtonGroup size="xs">
                    <IconButton
                        icon={<Icon name="refresh"/>}
                        isLoading={distributors.isFetching}
                        onClick={distributors.refetch}
                        aria-label='Refresh'
                    />
                    <Button leftIcon={<Icon name="add"/>} onClick={createDistributor.onOpen}>Novo núcleo</Button>
                    <Dev data={distributors}/>
                </ButtonGroup>
            </Flex>

            <Searchable
                value={term}
                setValue={setTerm}
                placeholder="Pesquisar por ID, Nome, E-mail, Código ou CNPJ..."
                isReadOnly={createDistributor.isOpen}
            />

            <HStack mt={2}>
                <Form.Select
                    label="Regiões"
                    placeholder="Região"
                    options={regionsOptions}
                    value={region}
                    onChange={e => setRegion(e.target.value)}
                />
                <Form.Select
                    label="Estados"
                    placeholder="Estados"
                    value={stateId}
                    options={statesList}
                    onChange={e => setStateId(e.target.value)}
                />

                <Form.Select
                    label="Cidades"
                    placeholder="Cidade"
                    value={cityId}
                    options={cityList}
                    onChange={e => setCityId(e.target.value)}
                />
                <Form.Select
                    label="Condições"
                    placeholder="Todas as condições"
                    options={conditionOptions}
                    value={condition}
                    onChange={e => setCondition(e.target.value)}
                />

                <Flex>
                    <Button
                        variant="outline"
                        onClick={handleClearFilters}
                        title="Filtros" mt={8}>
                            Limpar filtros
                    </Button>
                </Flex>
            </HStack>

            <Table
                columns={[
                    // {title: ''},
                    {title: 'Nome:'},
                    {title: 'Status:'},
                    {title: 'Telefone:'},
                    {title: 'Cidade:'},
                    {title: 'Estado:'},
                    {title: 'Cadastro', isNumeric: true}
                ]}
                meta={distributors.data?.meta}
                loading={distributors.isFetching}
                setPage={setPage}
            >
                {distributors.data?.data?.map(item => (
                    <Tr
                        key={item.id}
                        cursor="pointer"
                        onClick={() => navigate(`/distributors/${item.id}`)}
                        _hover={{backgroundColor: 'rgba(0,0,0,0.02)'}}
                    >
                        {/*<Td>{item.cod}</Td>*/}
                        <Td>
                            <HStack>
                                <Avatar size="xs" name={item.customer?.name} title={item.name}/>
                                <Pressable children={item.customer?.name} label={item.name} placement="top"/>
                            </HStack>
                        </Td>
                        <Td>
                            {!!item.blocked_at && <Tag size="sm" children="Bloqueado" colorScheme="red"/>}

                            {
                                item.active
                                    ? <Tag size="sm" children="Em Operação" colorScheme="teal"/>
                                    : <Tag size="sm" children="Vendas suspensas" colorScheme="orange"/>
                            }
                        </Td>

                        <Td>
                            <Text children={formatPhoneNumber(item.mobile)}/>
                        </Td>
                        <Td>{item?.city?.name}</Td>
                        <Td>{item?.city?.state?.iso2}</Td>

                        <Td isNumeric>{moment(item.created_at).calendar()}</Td>
                    </Tr>
                ))}
            </Table>

        <CreateDistributor {...createDistributor} onSuccess={distributors.refetch} />
        </Container>
    )
}